export default {
    name: 'focus',
    mounted(el, binding) {
        el.focus();
        if (binding.value)
            binding.value();
    }
};
